import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';

export interface SelfScheduledStateInfo {
  wakeAt: string;
  reason: string;
}

/**
 * Extract self-scheduled wake-up state from the co-scientist chat's application state.
 *
 * Returns null for non-co-scientist chats or when no schedule is active.
 */
export function getSelfScheduledState(
  agentType: AgentType | null,
  applicationState: object | null
): SelfScheduledStateInfo | null {
  if (agentType !== AgentType.CO_SCIENTIST || applicationState == null) {
    return null;
  }

  const state = applicationState as {self_schedule?: {wake_at?: unknown; reason?: unknown} | null};
  const selfSchedule = state.self_schedule;
  if (selfSchedule == null) {
    return null;
  }
  if (typeof selfSchedule.wake_at !== 'string' || typeof selfSchedule.reason !== 'string') {
    return null;
  }

  return {
    wakeAt: selfSchedule.wake_at,
    reason: selfSchedule.reason,
  };
}
